module.exports = __webpack_public_path__ + "img/supporto.142f16e6.png";